import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseFormComponent } from '../../base-form/base-form.component';
import { IRelatoriaCapituloModel } from 'src/app/models/relatoria-capitulo.model';
import { IRelatoriaConsolidada, IRelatoriaModel } from 'src/app/models/relatoria.model';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { RelatoriaService } from 'src/app/services/relatoria.service';
import { AprovacaoService } from 'src/app/services/aprovacao.service';
import { AvaliacaoService } from 'src/app/services/avaliacao.service';
import { MatDialog } from '@angular/material/dialog';
import { IBaseModel } from 'src/app/models/base.model';

@Component({
  selector: 'app-imprimir-consolidado-linha-do-tempo',
  templateUrl: './imprimir-consolidado-linha-do-tempo.component.html',
  styleUrls: ['./imprimir-consolidado-linha-do-tempo.component.scss']
})
export class ImprimirConsolidadoLinhaDoTempoComponent extends BaseFormComponent implements OnInit {
  relatoriaDados: IRelatoriaCapituloModel[];
  public dadosObtidos: IRelatoriaModel;
  relatoriasConsolidadas: IRelatoriaConsolidada[] = [];
  public tipoTrabalhoDescricao: any;
  public removeMinuta: boolean = true;
  visualizarRelatoriaHidden = false;
  tipoTrabalho;
  datas: any;
  activatedRoute: any;
  @Output() public abaRelatoria: EventEmitter<number> = new EventEmitter<number>();
  @Output() public voltarAbaRelatoria: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private relatoriaService: RelatoriaService,
    private aprovacaoService: AprovacaoService,
    private avaliacaoService: AvaliacaoService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {
    this.obterConsolidado();
  }


  public async obterConsolidado() {

    const idsParam = this.route.snapshot.paramMap.get('ids');

    if (!idsParam) {
      this.toastr.error('Nenhum ID informado para impressão.', 'Atenção');
      return;
    }

    const ids = idsParam
      .split(',')
      .map(x => Number(x.trim()))
      .filter(x => !isNaN(x));

    const tipoTrabalhoParam = this.route.snapshot.paramMap.get('tipoTrabalho');
    
    for (const id of ids) {
      try {
        const avaliacao = await this.aprovacaoService.imprimirRelatoria(id);

        if (!avaliacao?.sucesso) {
          continue;
        }

        const dadosRelatoria = JSON.parse(avaliacao.dados) as IRelatoriaModel;

        let tipoTrabalhoDescricao = '';
        let tipoTrabalho = null;

        switch (tipoTrabalhoParam) {
          case 'pea': tipoTrabalho = 1; tipoTrabalhoDescricao = 'PEAC'; break;
          case 'paa': tipoTrabalho = 2; tipoTrabalhoDescricao = 'PAAC'; break;
          case 'opa': tipoTrabalho = 3; tipoTrabalhoDescricao = 'OPA'; break;
          case 'osa': tipoTrabalho = 4; tipoTrabalhoDescricao = 'OSA'; break;
          case 'planejamento': tipoTrabalho = 7; tipoTrabalhoDescricao = 'Planejamento'; break;
          case 'execucao': tipoTrabalho = 15; tipoTrabalhoDescricao = 'Execução'; break;
        }

        const resultado = await this.avaliacaoService.obter(
          tipoTrabalho,
          dadosRelatoria.tipoTrabalhoId
        );

        this.relatoriasConsolidadas.push({
          id,
          dadosObtidos: dadosRelatoria,
          relatoriaDados: dadosRelatoria.relatoriasCapitulos,
          datas: resultado?.dados?.datas ?? [],
          tipoTrabalhoDescricao,
          removeMinuta: dadosRelatoria?.tipoTrabalhoStatus !== 4
        });

      } catch (e) {
        console.error('Erro ao imprimir ID:', id, e);
      }
    }

    if (this.relatoriasConsolidadas.length === 0) {
      this.toastr.error('Nenhum item válido para impressão.', 'Atenção');
    }

    this.visualizarRelatoriaHidden = true;
  }


  print(): void {
    window.print();
  }

  backClicked() {
    window.close()
  }

  VoltarRelatoria() {
    this.abaRelatoria.emit(5);
    this.voltarAbaRelatoria.emit(true);
    this.router.navigate(['/pea/', this.id]);
  }
}
